module.exports = __webpack_public_path__ + "img/gimpel.c12ee8e9.jpg";